export const ru = {
    cancel: 'Отменить',
    'crop-all-sizes': 'Обрезать все размеры',
    'crop-title': 'Обрезка изображения',
    'crop-updated-sizes': 'Обрезать измененные размеры'
};
